import { Button, Table, Spin, Modal, Select, Switch } from "antd";
import moment from "moment";
import Header from "../../../components/HeaderList";
import { ReactComponent as Edit } from "../../../assets/icons/edit.svg";
import { ReactComponent as Trash } from "../../../assets/icons/trash.svg";
import { getColumnSearchProps } from "../../../utils/tables";
import Editor from "./Editor";
import styles from "../styles/PuntosVentaUI.module.css";
import {useNavigate} from 'react-router-dom';
const { Option } = Select;

const PuntosVentaUI = (props) => {
  const {
    loading,
    puntoVenta,
    puntos,
    openEditor,
    editorVisible,
    closeEditor,
    newCategory,
    confirmDelete,
    handlePuntoVenta,
    types,
  } = props;

  const navigate = useNavigate();
  const getLocation = location => {
    try {
        if (!location) throw new Error("Location is null or undefined");

        let locationParse = JSON.parse(location);

        if (
            typeof locationParse !== "object" ||
            locationParse === null ||
            !("lat" in locationParse) ||
            !("lng" in locationParse) ||
            isNaN(locationParse.lat) ||
            isNaN(locationParse.lng)
        ) {
            throw new Error("Invalid location format");
        }

        return `${locationParse.lat},${locationParse.lng}`;
    } catch (error) {
        console.error("Error parsing location:", error.message);
        return "Invalid location";
    }
  };


  const getTypeName = (typeId) => {
    let name = "-";
    const index = types.findIndex((el) => el.id === typeId);
    if (index > -1) {
      name = types[index].type;
    }
    return name;
  };

  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      align: "center",
    },
    {
      title: "Nombre",
      dataIndex: "name",
      ...getColumnSearchProps("name"),
    },
    {
      title: "Categoría",
      align: "center",
      dataIndex: "typeId",
      render: val => getTypeName(val),
    },
    {
      title: "Ubicación",
      align: "center",
      dataIndex: "position",
      render: val => getLocation(val),
    },
    {
      title: "Editar",
      align: "center",
      dataIndex: "id",
      render: (id, record) => (
        <div className={styles.actions}>
          <div className={styles.edit} onClick={() => openEditor(record)}>
            <Edit />
          </div>
          <div className={styles.divider} />
          <div className={styles.delete} onClick={() => confirmDelete(id)}>
            <Trash />
          </div>
        </div>
      ),
    },
  ];

  return (
    <div className={styles.view}>
      <Header
        title="Puntos de venta"
        actions={
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              flexWrap: "wrap",
            }}
          >
            <Button
              onClick={() => {
                navigate('/puntos_venta/categorias');
              }}
              type="primary"
              size="large"
              className="main-button"
              style={{
                maxWidth: "200px",
                textAlign: "center",
              }}
            >
              VER CATEGORÍAS
            </Button>

            <Button
              onClick={newCategory}
              type="primary"
              size="large"
              className="main-button"
              style={{
                maxWidth: "200px",
                textAlign: "center",
              }}
            >
              NUEVO PUNTO DE VENTA
            </Button>
          </div>

        }
      />
      {loading ? (
        <div className={styles.loader}>
          <Spin size="large" />
        </div>
      ) : (
        <div style={{ overflowX: "auto", width: "100%" }}>
          <Table columns={columns} dataSource={puntos.puntosVenta} rowKey="id" />
        </div>
      )}
      <Modal
        destroyOnClose
        closable={false}
        visible={editorVisible}
        footer={false}
        onCancel={closeEditor}
        width={600}
      >
        <Editor
          close={closeEditor}
          puntoVenta={puntoVenta}
          handlePuntoVenta={handlePuntoVenta}
          types={types}
        />
      </Modal>
    </div>
  );
};

export default PuntosVentaUI;
